<template>
  <div class="Ordercontent">
    <van-tabs v-model="active" @click="changeTab">
		<van-tab title="新增">
			<van-cell-group class="addressBox">
				<van-cell title="地址" is-link value="点击选择地址" @click="gotoPath('/addressmanage')" class="addressBtn"/>
				<van-cell :value="saveData.address" class="address"/>
			</van-cell-group>      
			<van-cell-group>
				<van-cell title="原供热状态" :value="saveData.hotStatusName" />
			</van-cell-group>
			<van-cell-group>
				<van-cell title="操作" is-link :value="saveData.newStatusName" @click.stop="onStatus"/>
			</van-cell-group>
			
			<van-col span="24" type="flex" justify="space-between" class="barBtn">
			  <van-button round type="danger" size="large" class="saveBth" :disabled="isSave" @click.prevent="submit">保存</van-button>
			</van-col>
		</van-tab>
		<van-tab title="查看订单">
			<van-row  :disabled="item.status!=0" v-for="item in OrderList" :key="item.ID" v-if="OrderList">
			  <a href="javascript:;" class="billBar" @click="gotoOrderInfo(item)">
			    <van-col span="2">
			      <span class="Status StayColor" v-if="item.status == '0'">待</span>
			      <span class="Status Coloring" v-if="item.status == '1'">审</span>
				  <span class="Status CompleteColor" v-if="item.status == '1'">已</span>
			    </van-col>
			    <van-col span="23" offset="1">
			      <van-row >
			        <van-col span="24" class="cont">
			          <van-col span="24" class="address">{{item.roomInfo.roomAddress}}</van-col>
			          <van-col span="24" class="reason">{{item.createDate}}</van-col>
			        </van-col >
					<van-col span="12" class="statusText">原状态：<span class="orange">{{item.originalStatusText}}</span></van-col>
					<van-col span="12" class="statusText">变更状态：<span class="orange">{{item.changeStatusText}}</span></van-col>
					<van-col span="18" class="statusText">审核状态：<span class="orange">{{item.statusText}}</span></van-col>
			      </van-row>
			    </van-col>
			  </a>
			</van-row>
			<van-row  class="noPayBar" v-if="OrderList.length == 0">
			  <van-col span="24" class="noPayPC"></van-col>
			  <van-col span="24" class="text1 orange">没有变更记录！</van-col>
			  <van-col span="24" class="text2">去试试【新增供热状态变更】吧！</van-col>
			</van-row>
		</van-tab>
    </van-tabs>
	
	<van-popup v-model="showNewStatus" position="bottom">
		<van-picker
		  show-toolbar
		  :columns="newColumns"
		  @confirm="onConfirm"
		  @cancel="onCancel"
		  value-key="codeLabel"
		/>
	</van-popup>
  </div>
</template>

<script>
  import { Toast } from 'vant';
  import { Dialog } from 'vant';
  import { reqRoomInfo,saveProcessOrder,reqProcessOrderList,reqProcessOrderInfo,reqProcessCode } from '../../api'
	export default {
    name:"stop",
	  data(){
	    return{
			userId:'',
        active:0,
        saveData:{
			roomId:'',
          address:'请选择您所在地址',
		  hotStatus:'',
		  hotStatusName:'',
		  newStatus:'',
		  newStatusName:'选择变更状态'
        },
		showNewStatus:false,
		columns:[],
		newColumns:[],
        OrderList:[],
		isSave:true
      }
    },
    created(){
		this.userId = this.$cookies.get('userInfo').userId
		if(this.$route.query.roomId){
		  this.saveData.roomId = this.$route.query.roomId;
		  if(this.$cookies.get('address')){
		    this.saveData.address = this.$cookies.get('address')
		  }
		  this.getRoomInfo()
		}
		this.getHotStatus()
    },
    mounted(){
    },
    methods:{
		//跳转地址选择
		gotoPath(path){
		  this.$router.push({
		    path:path,
		    name:path.substring(1),
		    query:{type:2}
		  })
		},
		/*
		* 点击切换tab，通过active的不同来获取对应数据
		* */
		changeTab(){
		  if(this.active==0){
		    //新增
		    //this.orderData.status = '0,1,5,6,7,10'
		  }else if(this.active==1){
		    //列表
			this.getOrderList()
		  }
		  
		},
		getRoomInfo(){
			var data ={roomId:this.saveData.roomId,companyId:this.$cookies.get('companyId')}
			reqRoomInfo(data).then(res=>{
				if(res.success){
					var data = JSON.parse(res.data);					
					console.log(data);
					this.saveData.hotStatus = data.data[0].hotStatus;
					this.columns.forEach(item=>{
						if(this.saveData.hotStatus==item.codeValue){							
							this.saveData.hotStatusName = item.codeLabel
						}
					})
				}
			})
		},
		//列表
		getOrderList(){
			var data =  {userId:this.userId,type:"1",companyId:this.$cookies.get('companyId')}
			reqProcessOrderList(data).then(res=>{
				console.log(res);
				if(res.success){
					var listData = JSON.parse(res.data).data;
					console.log(listData);
					this.OrderList = listData.list;
					for(var i=0;i<this.OrderList.length;i++){
						if(this.OrderList[i].status=='0'){
							this.OrderList[i].statusText=="待审核"
						}else if(this.OrderList[i].status=='1'){
							this.OrderList[i].statusText=="审核中"
						}else if(this.OrderList[i].status=='2'){
							this.OrderList[i].statusText=="已审核"
						}
					}
				}
			})
		},
		//详情
		gotoOrderInfo(data){
			this.$cookies.remove('processorderInfo');
			this.$cookies.set('processorderInfo',data);
			this.$router.push({
			  path:'/detail',
			  name:'detail'
			});
		},
		//获取状态列表
		getHotStatus(){
			var params = {
				codeTypeValue:'hotstatus',
				companyId:this.$cookies.get('companyId')
			}
			reqProcessCode(params).then(res=>{
				console.log(res);
				if(res.success){
					if(res.data.length>0){
						this.columns = [];
						for(var i=0;i<res.data.length;i++){
							var item = {codeLabel:res.data[i].codeLabel,codeValue:res.data[i].codeValue}
							this.columns.push(item)
						}
					}
				}
			})
		},
		//提交变更状态
		submit(){
			if(this.testVerify()){
				var params = {changeStatus: this.saveData.newStatus,
							originalStatus:this.saveData.hotStatus,
							roomId: this.saveData.roomId,
							companyId:this.$cookies.get('companyId'),
							userId:this.$cookies.get('userInfo').userId,
							type: "1"}
				saveProcessOrder(params).then(res=>{
					if(res.success){
						this.active = 1;
						this.getOrderList()
					}
				})
			}
		},
		testVerify(){
			if(!this.saveData.roomId||!this.saveData.hotStatus){
			  Toast.fail({message:'请选择房屋地址！',className:'apiLoading'});
			  return false
			}
			if(!this.saveData.newStatus||this.saveData.hotStatus==this.saveData.newStatus){
			  Toast.fail({message:'请选择变更状态！',className:'apiLoading'});
			  return false
			}
			return true
		},
		//报停状态列表
		onStatus(){
			for(var i=0;i<this.columns.length;i++){
				if(this.columns[i].codeValue!=this.saveData.hotStatus){
					this.newColumns.push(this.columns[i])
				}
			}
			this.showNewStatus = true;
		},
		onConfirm(data){
			this.saveData.newStatus = data.codeValue;
			this.saveData.newStatusName = data.codeLabel;
			this.showNewStatus = false
			if(!this.testVerify()){
			  this.isSave = true
			}else{
			  this.isSave = false
			}
		},
		onCancel(){
			this.showNewStatus = false
		}
    }
  }
</script>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                  
<style lang="stylus" rel="stylesheet/stylus">
  @import "../../common/stylus/mixins.styl"
.Ordercontent
  padding-bottom 80px
  background #f9f9f9
  .van-tabs--line
    .van-tabs__wrap
      height 90px
    .van-tab
      font-size 30px
      line-height 80px
    .van-tab--active
      color #ff6d02
    .van-tabs__content
      padding-top 30px
	  .billBar
	    display inline-flex
	    padding 0px 40px 30px 0px
	    background #fff
	    border-top 20px solid #f9f9f9
	    .Status
	      position relative
	      top 25%
	      left 30%
	      display inline-block
	      padding 20px 20px
	      border-radius 50%
	      color #fff
	      font-size 32px
	    .StayColor
	      background #397ff0
	    .Coloring
	      background #ff6d02
	    .CompleteColor
	      background #d81b60
	    .van-row
	      padding-left 25px
	    .cont
	      border-bottom 2px solid #f0f0f0
	      font-size 28px
	      color #888888
	      padding 20px 0px
	    .address
	      font-size 30px
	      color #222222
	      line-height 40px
	      padding 20px 0px
	    .statusText
	      padding-top 20px
	      font-size 28px
	      color #888888
	.van-cell-group
      margin-top 8px
      .van-cell
        height 98px
        line-height 98px
        font-size 30px
        color #222222
        padding-left 40px
        .van-cell__value
          font-size 28px
        .van-cell__left-icon, .van-cell__right-icon
          font-size 26px
          margin 0px 10px
          line-height 98px
        .van-field__control
          text-align right
          padding-right 40px
        .van-field__label
          width 120px
  .noPayBar
    margin 10px 0px
    height 626px
    background #ffffff
    text-align center
    .noPayPC
      height 50%
      margin-top 15%
      background url("./images/unfound_5.png") no-repeat center
      background-size 50% auto
    .text1
      font-size 32px
      padding 20px 0px
    .text2
      font-size 24px
      color #aaaaaa
  .van-picker__toolbar
    height 85px
    .van-picker__confirm, .van-picker__cancel
      font-size 28px
      line-height 85px
  .van-picker-column
    font-size 32px
  .barBtn
    padding 10% 40px 0px
    .saveBth
      color #ffffff
      font-size 32px
      background #ff6d02
      height 88px
      margin-top 100px
      line-height 88px
  .van-popup
    box-sizing border-box
    padding 20px
    &--right
      width 100%
      height 100%
  .popCon
    width 100%
    height 100%
    position absolute
    background #ffffff
    top 0px
    left 0px
    padding-bottom 100px
    z-index 9
    .returnBtn
      background #ebedf0
      margin-bottom 10px
  .van-index-bar
    padding 0px 30px
    .van-index-bar__index
      font-size 24px
      line-height 40px
    .van-index-anchor
      font-size 30px
      background #ccc
      padding 8px 10px
    .van-cell
      font-size 28px
      padding 10px 20px
      line-height 45px
      border-bottom 1px solid #ccc
  .tagBox
    margin 0px 5%
    width 90%
  .tagBar
    margin 40px 20px
    .van-swipe-item
      display inline-block
      background #ff6d02
      width 130px!important
      margin 20px 10px
      color #fff
      border-radius 50%
      text-align center
      font-size 28px
      height 30px!important
      padding 50px 0px
  .van-picker-column__item
  	height 1rem
  .address
	height auto
	line-height 45px
.orange
	color #ff6d02
 
</style>



// WEBPACK FOOTER //
// src/pages/Stop/Stop.vue